import { Immutable } from "immer";
import React from "react";
import { usePageSetting } from "tsi-common-react/src/utils/settings";

type IProps = Immutable<{
    className?: string;
    preText?: string | React.ReactNode;
    linkText?: string | React.ReactNode;
}>;

export const CallLink = (props: IProps) => {
    const phoneNumberLink = usePageSetting("phone_number_link");
    const phoneNumberDisplay = usePageSetting("phone_number_display");
    return (
        <a className={props.className} href={phoneNumberLink || ""}>
            {props.preText}
            {props.preText && " "}
            {props.linkText || phoneNumberDisplay}
        </a>
    );
};
